import { render, staticRenderFns } from "./addpersonal.vue?vue&type=template&id=7b36f1a8&scoped=true"
import script from "./addpersonal.vue?vue&type=script&lang=js"
export * from "./addpersonal.vue?vue&type=script&lang=js"
import style0 from "./addpersonal.vue?vue&type=style&index=0&id=7b36f1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36f1a8",
  null
  
)

export default component.exports